/**
 * Render.com free tier goes cold after 15 minutes of inactivity.
 * Cold start = 300–800ms added to the FIRST API request.
 *
 * This module fires a lightweight ping to /api/ immediately when the
 * app loads — before any component even mounts — so the Render server
 * is warm by the time the real product fetch runs.
 *
 * The ping is fire-and-forget. It never blocks rendering.
 */

const API = process.env.REACT_APP_BACKEND_URL;

let warmed = false;

export function warmupApi() {
  if (warmed || !API) return;
  warmed = true;
  // Use fetch with keepalive so it completes even if user navigates away
  fetch(`${API}/api/`, {
    method: 'GET',
    keepalive: true,
    // Cache for 10s — if called twice quickly, uses browser cache
    cache: 'default',
  }).catch(() => {}); // Never throw — warmup is best-effort
}

// Auto-fire on import — runs before React even starts rendering
warmupApi();